import { Text } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import { isStrNullOrEmpty } from '../../../utils/strUtil';
import InputCheckbox from '../../generic/form/InputCheckbox';

const textProps = {
  as: 'span',
  fontSize: '12px',
};

export const OPT_IN_SMS_FIELDNAME = 'opt_in_sms';

const CheckoutOptInSms = ({ phoneValue, ...dataProps }) => {
  return (
    <InputCheckbox fieldName={OPT_IN_SMS_FIELDNAME} {...dataProps} isRequired={false} isDisabled={isStrNullOrEmpty(phoneValue)}>
      <Text {...textProps}>
        <Trans>I agree to receive SMS related to my booking</Trans>{' '}
      </Text>
    </InputCheckbox>
  );
};

export default CheckoutOptInSms;
